export const COUNT_CAP = 500

export type CountResult = { count: number; isApprox: boolean }

type FilterModelLike = { quickFilterValues?: readonly unknown[] | null } | null | undefined

export const shouldCapCount = (filterModel: FilterModelLike): boolean => (filterModel?.quickFilterValues?.length ?? 0) > 1

export const mapCappedCount = (rawCount: number, cap: number = COUNT_CAP): CountResult => ({
  count: Math.min(cap, rawCount),
  isApprox: rawCount > cap,
})

export const resolveCount = (rawCount: number, filterModel: FilterModelLike, cap: number = COUNT_CAP): CountResult =>
  shouldCapCount(filterModel) ? mapCappedCount(rawCount, cap) : { count: rawCount, isApprox: false }
